// Pre-checkout modal gateway.
// Intercepts clicks on the primary and secondary checkout buttons, shows a
// modal with sign-in/guest options. The "Continue as Guest" submit button
// already has form="cart" so it submits the cart to Shopify checkout.
(function () {
  const MODAL_ID = 'epi-checkout-modal';
  const BUTTON_SELECTOR = '#checkout, #checkout-secondary';

  let lastFocus = null;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function openModal(triggerEl) {
    const modal = getModal();
    if (!modal) return;

    lastFocus = triggerEl || document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('epi-modal-open');

    // Focus the first focusable element in the modal
    const focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();

    document.addEventListener('keydown', handleKeydown);
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('epi-modal-open');

    // Wait for transition before hiding
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 320);

    document.removeEventListener('keydown', handleKeydown);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    }
  }

  function handleButtonClick(e) {
    const btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    // Only intercept the original checkout buttons — not buttons inside the modal.
    if (btn.closest('#' + MODAL_ID)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(btn);
  }

  function handleCloseClick(e) {
    if (e.target.closest('[data-epi-modal-close]')) {
      e.preventDefault();
      closeModal();
    }
  }

  function init() {
    // Capture-phase listener on document so we intercept before the browser
    // submits the form via the type="submit" button.
    document.addEventListener('click', handleButtonClick, true);
    document.addEventListener('click', handleCloseClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
